export const getCrosswordAnswers = async (axios, config, params = {}) => {
	return await axios
		.get(`${config.API_SERVICE}/v1/wordlist`, {
			params: {
				dictionary: "CROSSWORD",
				order_by: "alpha",
				limit: 0,
				...params,
			},
		})
		.then((response) => {
			return response.status === 200
				? response.data?.data?._items || []
				: [];
		})
		.catch((err) => {
			if (err.response.status === 404) {
				return [];
			}

			console.error(
				"Could not connect to the crossword solver endpoint. ",
				err
			);

			return [];
		});
};
